export const formatToRu = (i: number) => new Intl.NumberFormat('ru-RU').format(i);

export const roundNumber = (number: number, decimals: number) => {
  const h = 10 ** decimals;
  return Math.round(number * h) / h;
};

const numberFormattersCache = new Map();

export const getNumberFormatter = (locale: string, options: Intl.NumberFormatOptions) => {
  const key = `${locale}_${JSON.stringify(options)}`;

  if (!numberFormattersCache.has(key)) {
    numberFormattersCache.set(key, new Intl.NumberFormat(locale, options));
  }

  return numberFormattersCache.get(key);
};
